import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const confirmTimeKeepingMonthSlice = createSlice({
  name: "confirmTimeKeepingMonth",
  initialState,
  reducers: {
    confirmTimeKeepingMonthStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    confirmTimeKeepingMonthSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    confirmTimeKeepingMonthFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  confirmTimeKeepingMonthStart,
  confirmTimeKeepingMonthSuccess,
  confirmTimeKeepingMonthFailed,
} = confirmTimeKeepingMonthSlice.actions;

export default confirmTimeKeepingMonthSlice.reducer;
